var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFamilyinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(41.78 7)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m.842 21.614 5.046-6.905a4 4 0 0 1 3.23-1.64h7.122c.728 0 1.696.7 1.788 1.618l2.533 16.347H4.39l1.797-10.779"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12.476,
  cy: 4.984,
  r: 4.491
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.786 49h3.38a2 2 0 0 0 1.998-1.9l.804-16.066H7.985L8.788 47.1a2 2 0 0 0 1.998 1.9z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.22 7.254)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m17.22 20.677 5.61 13.974H0l8.27-20.017a2 2 0 0 1 1.849-1.236h4.41q.81 0 1.848 1.236l6.21 6.706M10.444 48.82h1.943a2 2 0 0 0 1.967-1.635l2.33-12.534H6.147l2.33 12.534a2 2 0 0 0 1.966 1.635z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 5.238,
  r: 4.491
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(25.78 23)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 7.476,
  cy: 4.441,
  r: 3.611,
  transform: "matrix(-1 0 0 1 14.952 0)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.944 8.718q3.65 4.14 4.76 4.14h4.576c.464 0 3.728-4.14 3.728-4.14m-1.928 6.674c.212 1.37.53 6.18.955 8.92H2.727l.825-8.483m3.915 17.465h.828a2 2 0 0 0 1.996-1.873l.453-7.11H5.017l.454 7.11a2 2 0 0 0 1.996 1.873z"
})))));
export default SvgFamilyinline;